// Do not import from tradeSettingsStoreACTIONS here: its module scope reads this
// file's consts, so a value import back at it creates a TDZ cycle under ESM.

export const defaultTradeTypes = [
  { name: "RFQ", active: true },
  { name: "Order", active: false },
];
// "quoteType": Set default to "One-Way"
export const defaultQuoteTypeOptions = [
  { name: "One-Way", active: true },
  // { name: "Mid", active: false }, // Add this line back in for mid to work.
  { name: "Two-Way", active: false },
];
// "releasedirection": Set default to true
export const defaultReleaseDirectionOptions = [
  { name: "Show", active: true, booleanValue: true }, // Default to true
  { name: "Withhold", active: false, booleanValue: false },
];
// "releaseSize": Set default to 1
// "releaseCompetition": Set default to false. LQC-627 — labels Yes/No, API stays boolean.
export const defaultReleaseCompetitionOptions = [
  { name: "Yes", active: false, booleanValue: true },
  { name: "No", active: true, booleanValue: false }, // Default as No (false)
];
// "releaseCover": Set default to False. Labels Yes/No, API stays boolean.
export const defaultReleaseCoverOptions = [
  { name: "Yes", active: false, booleanValue: true },
  { name: "No", active: true, booleanValue: false }, // Default as No (false)
];
// "releaseCounterparty": trade-wide only. Default "True". LQC-621
export const defaultReleaseCounterpartyOptions = [
  { name: "True", active: true, booleanValue: true }, // Default as True
  { name: "False", active: false, booleanValue: false },
];
// "releaseCoverSpread": per-CP Yes/No. Default "No". Labels Yes/No, API stays
// boolean. LQC-1705 (was trade-wide tri-state None/Non-Awarded/All, LQC-673).
export const defaultReleaseCoverSpreadOptions = [
  { name: "Yes", active: false, booleanValue: true },
  { name: "No", active: true, booleanValue: false }, // Default as No (false)
];
// "autoAffirm": Set default to false
export const defaultAutoAffirmOptions = [
  { name: "Yes", active: false, booleanValue: true },
  { name: "No", active: true, booleanValue: false }, // Default false
];
// "level": Set default to NULL
// "referenceAsset": Set default to NULL
// "referencePrice": Set default to NULL
// "releaseAllocation": Set default to true
export const defaultReleaseAllocationOptions = [
  { name: "True", active: true, booleanValue: true }, // Default as True
  { name: "False", active: false, booleanValue: false },
];
// "releaseSecurity": Set default to true
export const defaultReleaseSecurityOptions = [
  { name: "True", active: true, booleanValue: true }, // Default as True
  { name: "False", active: false, booleanValue: false },
];

// Order-specific settings
// "orderSetLevelStructure": Set default to "Spread"
// Structure
export const defaultOrderSetLevelStructureOptions = [
  // { name: "Spread", active: true },
  { name: "Spread / Legs", active: true },
  { name: "Market", active: false },
  // { name: "Legs", active: false },
];
// Outright
export const defaultOrderSetLevelOutrightOptions = [
  { name: "Leg", active: true },
  { name: "Market", active: false },
  // { name: "Spread", active: false },
];
// "orderSpreadType": Set default to "Limit"
export const defaultOrderSpreadAndPriceTypeOptions = [
  // { name: "Limit", active: true },
  // { name: "Stop", active: false },
];

// "expiryType": Set default to "GTC". LQC-2170 restored GTC/Day/Time.
export const defaultOrderExpiryTypeOptions = [
  { name: "GTC", active: true },
  { name: "Day", active: false },
  { name: "Time", active: false },
  // { name: "IOC", active: false }, // Add back when IOC is supported.
  // { name: "FOK", active: false }, // Add back when FOK is supported.
];
